const recaptchaSiteKey = String(
  process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY || '',
).trim();

export default recaptchaSiteKey;
